// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-content[data-v-5193ee2a]{background-color:#fff;padding:3rem}.modal-content footer[data-v-5193ee2a]{display:flex;justify-content:flex-end;align-items:center;padding-top:1rem}.modal-content footer button[data-v-5193ee2a]:last-child{margin-left:1rem}.text-center[data-v-5193ee2a]{text-align:center}", ""]);
// Exports
module.exports = exports;
